import posthog from "posthog-js";
import { track } from "./analytics";

// Grab the current PostHog person id so the purchase captured server-side
// (from the Stripe webhook) stitches to the same person who clicked buy.
const getDistinctId = () =>
  typeof window !== "undefined" ? posthog.get_distinct_id?.() : undefined;

export const handleCheckoutSession = async (
  price_id,
  discount,
  tier,
  location = "unknown",
) => {
  // Leading indicator: which placement drives buy clicks (hero, pricing, cta…).
  track("clicked_buy_button", { location, tier });

  const response = await fetch("/api/checkout", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      price_id,
      discount,
      distinct_id: getDistinctId(),
    }),
  });

  const data = await response.json();
  window.location.href = data.sessionUrl;
};

export const handleCheckoutSessionExperiment = async (
  price_id_control,
  price_id_test,
  discount,
  tier,
  location = "unknown",
) => {
  track("clicked_buy_button", { location, tier });

  const isTest = posthog.getFeatureFlag("price-comparison") === "test";
  const response = await fetch("/api/checkout", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      price_id: isTest ? price_id_test : price_id_control,
      discount,
      distinct_id: getDistinctId(),
    }),
  });

  const data = await response.json();
  window.location.href = data.sessionUrl;
};
